var map = {
	"./casino/components/conf.js": "WTBl",
	"./default/components/conf.js": "22OE",
	"./marketmaker/components/conf.js": "K25W"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pdUy";


//////////////////
// WEBPACK FOOTER
// ./src/companies ^\.\/.*\/components\/conf\.js$
// module id = pdUy
// module chunks = 1